import { render } from "./AboutUsComponent.vue?vue&type=template&id=59c6b35c&scoped=true"
import script from "./AboutUsComponent.vue?vue&type=script&lang=js"
export * from "./AboutUsComponent.vue?vue&type=script&lang=js"

import "./AboutUsComponent.vue?vue&type=style&index=0&id=59c6b35c&scoped=true&lang=scss"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c6b35c"]])

export default __exports__